module.exports = __webpack_public_path__ + "img/dark-angle-half-moon.0a62368.svg";